<template>
  <v-container fill-height fluid :style="bgImg">
    <v-layout fluid fill-height align-center justify-center
      >
      <v-card
        width="475px"
        height="475px"
        class="elevation-20 rounded-10"        
        @keydown.enter.prevent="checkLogin"
      >
        <v-card-title>
          <div class="qmkey-login-logo-container layout column align-center ">
            <v-img
              center
              src="../assets/logo_earcon.gif"
              alt="Sede Logo"
              max-width="340px"
              max-height="120px"
              contain>
            </v-img>
          </div>
        </v-card-title>
        <v-card-subtitle class="login-card-subtitle pb-5">
          User Login
          <v-divider class="login-card-subtitle-divider"></v-divider>
        </v-card-subtitle>
        

        <v-card-text>
          <v-form
            class="qmkey-login-form"
            autocomplete="off"
          >
            <v-text-field
              id="username"
              name="username"
              label="User Name"
              type="text"
              v-model="creds.username"
              required
              placeholder="username"
              outlined
              dense
              class="qmkey-login-input"
            />
            <v-text-field
              id="password"
              name="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              v-model="creds.password"
              label="Paswword"
              required
              placeholder="PASSWORD"
              @click:append="show1 = !show1"
              automcomplete="new-password"
              outlined
              dense
              class="qmkey-login-input"
            />
          </v-form>
          <div class="qmkey-login-router-link text-right">
            <router-link
              class="pointer"
              to="/forgotten-password"
            >
              Forgot Password?
            </router-link>
          </div>
          <div>
            <v-alert
              dense
              outlined
              type="error"
              v-model="alert"
              dismissible
            >
              {{ message }}
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            rounded
            large
            min-width="150px"
            class="qmkeky-login-button"
            @click.prevent="checkLogin"
          >
            Log In
          </v-btn>
        </v-card-actions>
        <v-container>
        <v-row >
            <v-col class="text-right" cols="12">
              <v-chip
                color="white"
                label
                :ripple="false"
                class="login-notice"
                x-small
              >Powered by              <v-img
              src="../assets/logo.png"
              alt="Sede Logo"
              max-width="50px"
              max-height="50px"
              class="ml-auto"
              small
              >
                  
            </v-img></v-chip>
            <v-spacer></v-spacer>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'app_login',
  cache: false,
  data: function() {
    return {
      message: '',
      creds: { username: null, password: null },
      loading: false,
      sede_logo_path:'../assets/logo_earcon.gif',
      show1: false,
      alert: false,
      bgImg: {
            backgroundImage: `url(${require('../assets/logos/bgsalud1920x1080.jpg')})`
          }
    }
  },
  // mounted() {
  //   // Keypresses on overlay:
  //   document.addEventListener('keydown', this.onKeydown)
  // },

  methods: {
    getUserInfoAndRedirect: function(site_path) {
      this.$http
        .get(this.$base + '/api/v1' + site_path + '/site/current/')
        .then(response => {
          // Set store data triggering action on store direct way
          this.$session.set('site_data', response.data)
          this.$http
            .get(this.$base + '/api/v1' + site_path + '/user/current/')
            .then(response => {
              this.$session.set('user', response.data)
              this.REFRESH_STATE(this)
              if (this.$session.get('user')) this.$router.push('preferences')
            })
        })
    },
    checkLogin: function() {
      this.loading = true
      this.message = ''
      this.$session.remove('user')
      this.$session.remove('site')
      localStorage['vue-authenticate.vueauth_token'] = ''
      this.$http
        .post(this.$base + '/api/v1/rest-auth/login/', this.creds)
        .then(response => {
          localStorage['vue-authenticate.vueauth_token'] = response.data['key']
          this.$http
            .get(this.$base + '/api/v1/token/' + response.data['key'] + '/')
            .then(response => {
              this.loading = false
              this.alert = false
              this.$session.set('root_site', response.data['user'])
              this.$session.set('site', response.data['user'])
              this.getUserInfoAndRedirect(response.data['user'])
            })
        })
        .catch(err => {
          this.render_form_errors(err)
          this.alert = true
        })
    },
    ...mapActions(['REFRESH_STATE']),
    
    // TODO: Backgroud image must loaded from site product (qmkey, health,
    // food, ...)
    getBackgroundImage: function(){
      return {
        backgroundImage: `url(../assets/logos/bg_salud_1920x1080.jpg)`
      }      
    }
  },
}
</script>


<style lang="scss">
 @import "@/sass/login.scss";
</style>
